module.exports = __webpack_public_path__ + "ua.svg?e2202cb676678f90c10a1c1a0e04afa6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/ua.svg
// module id = 1668
// module chunks = 0